import { useEffect } from 'react';
import './cta-component.scss';
import '../../../default/components/cta-component/cta-component.scss';
import { useHiddenField } from '../../../common/hooks/useHiddenField';

export function CtaComponent() {

  useEffect(() => {
    const link = document.createElement('link');
    link.media = 'all';
    link.rel = 'stylesheet';
    link.href = 'https://ms.quirinprivatbank.de/assets/webflow_forms.css?body=1';
    document.head.insertBefore(link, document.head.firstChild);

    const script = document.createElement('script');
    script.src = 'https://ms.quirinprivatbank.de/assets/external_forms.js?body=1';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);

  useHiddenField(
    'qpb-form',
    'third_eyes_pdf',
    async (input) => {
      const stateString = localStorage.getItem('persist:root');
      if (!stateString) return;

      // btoa breaks on unicode → encode safely
      const base64 = btoa(
        unescape(encodeURIComponent(stateString)),
      );

      input.value = base64;
    },
  );

  return (<div
    className="quirion-cta-component-body">
      <div
        id="qpb-form"
        data-form-base-id="1159"
        data-content-article-form-id="2479"
        data-tag=""
        className='webflow-form qpb-form'>
      </div>
    </div>);


}

export default CtaComponent;
